import {
  getCurrentUserFromStore,
  getUserRoleConfigFromStore,
} from "../../Constants/Utilities";

export const Access = {
  user: {
    updatePassword: "updatepassword",
    notification: "notification",
    notificationNeworder: "notification_neworder",
    betaRedirect:"betaportal_redirect"
  },
  menu: {
    support: "support",
    device: "device",
    order: "order",
    asset: "asset",
    group: "group",
    network: "network",
    troubleshooting: "troubleshooting",
    adminSettings: "adminsettings",
    help: "help",
    tips: "tips",
    statistics: "statistics",
  },
};

export const getUserFeatureList = (userRoles, roleConfig) => {
  let roles = userRoles;
  if (!userRoles) {
    const currentUser = getCurrentUserFromStore();
    const features = currentUser?.userFeatures;
    if (features && features.length) {
      return features;
    }
    roles = currentUser?.roles || [];
  }
  let config = roleConfig;
  if (!roleConfig) {
    config = getUserRoleConfigFromStore();
  }
  const features = new Set();
  roles.forEach((role) => {
    !!config[role] && config[role].forEach((feature) => features.add(feature));
  });
  console.log("Computing User Features...!");
  return Array.from(features) || [];
};
